// extracted by mini-css-extract-plugin
module.exports = {"load-more":"load-more","bm-btn":"bm-btn","is-next":"is-next","is-prev":"is-prev","is-primary":"is-primary"};